// extracted by css-extract-rspack-plugin
export default {"wysiwyg":"header-fragment__Wysiwyg_wysiwyg__IaBpx"};